// extracted by mini-css-extract-plugin
module.exports = {"tabPanel":"SystemItemDataInsert_tabPanel__3Gt55"};